import { ThemeProvider, createTheme } from "@mui/material";
import { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from "react-redux";
import MainPage from '../Views/Pages/Main';
import Dashboard from "../Views/Pages/Dashboard";

import { BrowserRouter, Route, Routes } from "react-router-dom";
const getActiveTheme = (themeMode) => {
  console.log('themeMode: ', themeMode)
  return createTheme({
    pageColor: '#000',

    bgPrimary: '#161616',
    bgSecondary: 'red',

    textPrimary: '#00FF00',
    textSecondary: 'black',
    textTertiary: '#00FF00',
    bgTertiary: '#00FF00',
    switchColor: '#b1b1b1',
  })
}
const ThemeContainer = () => {
  const currentTheme = useSelector((state) => state.LDTheme.value);
  const [activeTheme, setActiveTheme] = useState(getActiveTheme(currentTheme));

  useEffect(()=>{    
    setActiveTheme(getActiveTheme(currentTheme))
  },[currentTheme]);
  return (
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
        <Route exact path="/" element={<MainPage />} />
          <Route exact path="/dashboard" element={<Dashboard />} />
          </Routes>
      </BrowserRouter>
      {/* <MainPage toggleTheme='' /> */}
    </ThemeProvider>
  );
}

export default ThemeContainer;